import { AnyAction, ReducersMapObject } from 'redux';
import { all, fork } from 'redux-saga/effects';

// Get All by person id
import { shareholderGetAllByPersonIdReducer } from 'reducer/shareholder/get-all-by-person-id/reducer';
import shareholderGetAllByPersonIdSagas from 'reducer/shareholder/get-all-by-person-id/sagas';
import { ShareholderGetAllByPersonIdState } from 'reducer/shareholder/get-all-by-person-id/types';

// Get shareholder documents
import { getShareholderDocumentsReducer } from 'reducer/shareholder/get-shareholder-documents/reducer';
import getShareholderDocumentsSagas from 'reducer/shareholder/get-shareholder-documents/sagas';
import { GetShareholderDocumentsState } from 'reducer/shareholder/get-shareholder-documents/types';

// Download shareholder document
import { downloadShareholderDocumentReducer } from 'reducer/shareholder/download-shareholder-document/reducer';
import downloadShareholderDocumentSagas from 'reducer/shareholder/download-shareholder-document/sagas';
import { DownloadShareholderDocumentState } from 'reducer/shareholder/download-shareholder-document/types';

export interface ShareholderState {
    shareholderGetAllByPersonId: ShareholderGetAllByPersonIdState;
    getShareholderDocuments: GetShareholderDocumentsState;
    downloadShareholderDocument: DownloadShareholderDocumentState;
}

export const shareholderReducer: ReducersMapObject<ShareholderState, AnyAction> = {
    shareholderGetAllByPersonId: shareholderGetAllByPersonIdReducer,
    getShareholderDocuments: getShareholderDocumentsReducer,
    downloadShareholderDocument: downloadShareholderDocumentReducer
};

export function* shareholderSagas() {
    yield all([fork(shareholderGetAllByPersonIdSagas), fork(getShareholderDocumentsSagas), fork(downloadShareholderDocumentSagas)]);
}
